<div class="snack-bar-content">
    <img [src]="data.iconPath" class="snack-bar-icon" alt="Notification Icon">
    <span [innerHTML]="data.message"></span>
    <img [src]="data.actionIconPath" class="snack-bar-action-icon" (click)="data.actionClick()" alt="action icon"/>
  </div>
  